import { gql } from '@apollo/client';

import { QueryWorkshopServiceAvailableDates } from './serviceAvailableDates';
import { QueryWorkshopServiceLocationFinder } from './serviceLocationFinder';
import { FragmentService } from '../../fragments/services';

export const QueryServiceCategories = gql`
  query ServiceCategories {
    workshopServiceCategories {
      id
      title
      name
      services {
        ...FragmentService
      }
    }
  }
  ${FragmentService}
`;

export {
  QueryWorkshopServiceAvailableDates,
  QueryWorkshopServiceLocationFinder,
};
